import React from 'react';

const ErrorPage = () => {
  return (
    <div class="grid h-screen mt-20 col-span-2 bg-white">
      <div class="text-center">
        <strong class="text-9xl font-black text-gray-200">404</strong>

        <h1 class="text-2xl font-bold tracking-tight text-gray-900 sm:text-4xl">
          Uh-oh!
        </h1>

        <p class="mt-4 text-gray-500">We can't find that page.</p>
      </div>
    </div>


  );
};

export default ErrorPage;